import {useIntl} from 'react-intl'
import {NavLink} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {ROUTES} from '../../../../_gori/constants'
import {useAuth} from '../../auth'

export function HelpCenterHeader() {
  const intl = useIntl()
  const {currentUser} = useAuth()

  return (
    <header className='public-hc-header'>
      <nav className='navbar navbar-expand-md navbar-light bg-white fixed-top border-bottom shadow-sm'>
        <div className='container flex-nowrap'>
          {/* Logo */}
          <NavLink to={'/help-center'} className='navbar-brand p-0'>
            <img
              alt='ShipBae Powered By Gori.ai'
              src={toAbsoluteUrl('/media/logos/help-center-logo.svg')}
            />
          </NavLink>

          {!currentUser && (
            <NavLink
              to={ROUTES.AUTH.BASE}
              className='btn btn-advanced-secondary darker fs-4 text-capitalize rounded-pill py-3 px-6'
            >
              {intl.formatMessage({id: 'LOG_IN'})}
            </NavLink>
          )}
        </div>
      </nav>
    </header>
  )
}
